import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCropNutrition } from 'api/requests';

export const fetchCropNutrition = createAsyncThunk(
    'cropNutrition/fetchCropNutrition',
    async ({ language = 'en', country = 'en' } = {}) => {
        try {
            const response = await getCropNutrition(language, country);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    {
        condition: (_, { getState }) => {
            const { cropNutrition } = getState();
            if (cropNutrition.data) return false;
        },
    },
);

const cropNutritionSlice = createSlice({
    name: 'cropNutrition',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCropNutrition.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCropNutrition.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCropNutrition.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default cropNutritionSlice.reducer;
